/*
* @Author: 王春岩 <Bolt>
* @Date:   2016-12-21 16:30:56
* @Last Modified by:   Bolt
* @Last Modified time: 2016-12-21 19:46:22
*/

'use strict';

require('./riot/Diana.js');



// WEBPACK FOOTER //
// ./src/modules/helpfind/index.js